import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdMediaList = lazyNamed(() => import('./containers/AdMediaList/index.tsx'), 'AdMediaList');
export const AdMediaForm = lazyNamed(() => import('./containers/AdMediaForm/index.tsx'), 'AdMediaForm');
export const AdMediaHistory = lazyNamed(() => import('./containers/AdMediaHistory/index.tsx'), 'AdMediaHistory');
export { AdPrice } from './containers/AdPrices/index.tsx';
export { AdTypes } from './containers/AdTypes/index.tsx';
export { Placement } from './containers/Placements/index.tsx';
export { Products } from './containers/Products/index.tsx';
export { AdMediumMapping } from './containers/AdMediumMapping/index.ts';

export const Layout = lazyNamed(() => import('./components/Layout.tsx'), 'Layout');
